import httpClient from './httpClient'
export default {
  Timezone: {
    getTimezone(payload) {
      return httpClient.get('/Time/GetAllTimeZones', payload)
    },
  },
}
